import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
import { baseUrl } from "@/config/env";

export const preFilterOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "服务单编号",
      prop: "serveOrderNumber",
      formsolt: true,
    },
    {
      label: "二维码名称",
      prop: "qrcodeName",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 商品二维码仅搜索
    /* {
      label: "商品二维码",
      prop: "qrId",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
      search: true,
    }, */
    {
      label: "安装商品",
      search: true,
      prop: "goodsName",
      formsolt: true,
    },
    {
      label: "一级分类",
      prop: "firstClassifyName",
      formsolt: true,
    },
    {
      label: "二级分类",
      prop: "secondClassifyName",
      formsolt: true,
    },
    {
      label: "品牌",
      prop: "brandName",
      formsolt: true,
    },
    {
      label: "经销商",
      search: true,
      prop: "shopName",
      formsolt: true,
    },
    {
      label: "店铺名称",
      search: true,
      prop: "storeName",
      formsolt: true,
    },
    {
      label: "店铺地址",
      prop: "storeAddress",
      formsolt: true,
    },
    {
      label: "用户姓名",
      search: true,
      prop: "userName",
      type: "input",
    },
    {
      label: "用户电话",
      search: true,
      prop: "mobile",
      type: "input",
    },
    {
      label: "用户地址",
      search: true,
      prop: "address",
      type: "input",
    },
    {
      label: "服务工程师",
      search: true,
      prop: "receiver",
      type: "input",
    },
    {
      label: "工程师账号",
      search: true,
      prop: "account",
      type: "input",
    },
    {
      label: "照片",
      prop: "imageUrl",
      type: "input",
      solt: true,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: DIC.PRE_FILTER_STATUS,
      search: true,
      solt: true,
      addVisdiplay: false,
    },
    {
      label: "来源",
      prop: "source",
      type: "select",
      search: true,
      dicData: DIC.PRE_FILTER_SOURCE,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "安装时间",
      prop: "installationTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "开始时间",
      search: true,
      prop: "startTime",
      type: "datetime",
      hide: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      search: true,
      prop: "endTime",
      type: "datetime",
      hide: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
